import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTooltipIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 25,
	height: 24,
	viewBox: "0 0 25 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_11278_110480)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M9.5 3L15.5 3C17.7091 3 19.5 4.79086 19.5 7L19.5 17C19.5 19.2091 17.7091 21 15.5 21L9.5 21C7.29086 21 5.5 19.2091 5.5 17L5.5 7C5.5 4.79086 7.29086 3 9.5 3Z",
				stroke: "#2C70EC",
				strokeWidth: 1.5
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M9.77393 9.24125C9.77393 6.21683 14.5263 6.21683 14.5263 9.24125C14.5263 11.4014 12.3662 10.9692 12.3662 13.5615",
				stroke: "#2C70EC",
				strokeWidth: 1.5,
				strokeLinecap: "square"
			}),
			/* @__PURE__ */ _jsx("circle", {
				cx: 12.4883,
				cy: 16.2771,
				r: .75,
				fill: "#2C70EC"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_11278_110480",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 16,
			height: 20,
			fill: "white",
			transform: "translate(4.5 2)"
		})
	}) })]
});
export default SvgTooltipIcon;
